import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { resetManageUsersModalsReducer } from "../../../../redux/slices/components/ManageUsers/manageUsersModalsSlice"
import { RootState, useAppDispatch } from '../../../../redux/store/store'
import LoadingSpinner from "../../../LoadingSpinner"
import ConfirmButton from '../../../UIcomponents/Modals/ConfirmButton/ConfirmButton'
import TitleModal from '../../../UIcomponents/Modals/TitleModal/TitleModal'
import "./EditUserRoleModal.css"
import InputList from "../../../UIcomponents/InputList/InputList"
import { Role } from "../../../../redux/slices/components/ManageRoles/manageRolesSlice"
import { getProfilePictureByUserId, updateUserRole } from "../../../../utils/requestsUtils/functionsRequests/user/userFunctions"
import { updateEditedUsersReducer, updateRoleUsersReducer } from "../../../../redux/slices/components/ManageUsers/manageUsersDataSlice"
import useGetAllJobNames from "../../../hooks/useGetAllJobNames/useGetJobName"
import { getTransactionCounterJobsTasksHistory } from "../../../../utils/requestsUtils/functionsRequests/transactions/history"

const EditUserRoleModal = () => {
    
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const jobNames = useGetAllJobNames()

    const [loading, setLoading] = useState<boolean>(false)
    const { id, firstName, lastName, roleId: role, gimScore, gimmerScore, gimmerJobs, jobs, Tax_Information, nss_information, roleId,
        GimTransactionsCancelled,
        GimTransactionsTotal,
        GimTransactionsFinished,
        GimmerTransactionsCancelled,
        GimmerTransactionsTotal,
        GimmerTransactionsFinished,
     } = useSelector((state: RootState) => state.manageUsersModals.editUserRoleModal)
    const roles = useSelector((state: RootState) => state.manageUsersModals.roles)
    const [roleValue, setRoleValue] = useState<Role>({} as Role)
    const [error, setError] = useState<string>("")
    const [imgUrl, setImgUrl] = useState("/assets/images/profilePic.png")
    const [transactionsInfo, setTransactionInfos] = useState({
        numberTasks: 0,
        numberJobs: 0
    })

    const isSuperAdmin = roleId === "Super_Admin"

    const closeModal = () => {
        dispatch(resetManageUsersModalsReducer())
    }

    const selectRole = (role: Role) => {
        if(error)
            setError("")
        setRoleValue(role)
    }

    const handleSubmit = (e: any) => {
        e.preventDefault()

        if(!roleValue.id){
            setError("You must select a role")
            return
        }

        setLoading(true)
        updateUserRole(id, { id_Role: roleValue.id })
        .then(() => {
            dispatch( updateRoleUsersReducer({ userId: id, roleId: roleValue.id}) )
            closeModal()
        })
        .catch(() => {
            alert("General:Error updating role")
        })
        .finally(() => {
            setLoading(false)
        })
    }

    useEffect(() => {
      
        const getData = () => {
            getProfilePictureByUserId(id)
            .then((link: string) => {
                setImgUrl(link)
            }).catch(() => {

            })

            getTransactionCounterJobsTasksHistory(id)
            .then(({ numberJobs, numberTasks }) => {
                setTransactionInfos({ numberJobs, numberTasks })
            }).catch(() => {

            })
        }

        getData()

    }, [])




    useEffect(() => {
      
        const role = roles.find((role) => roleId === role.id)
        if(role)
            setRoleValue(role)

    }, [roles])
    
    

    return (
        <form onSubmit={handleSubmit} className="blank-wrapper-modals flex flex-d-column p-relative" style={{ height: "69rem", width: "65rem" }}>
            <button onClick={closeModal} className="p-absolute close-modal-icon pointer">
                <FontAwesomeIcon  icon={solid("times")} className="c-manatee fs-14"/> 
            </button>
            <TitleModal title={`${t("General:label_142")} ${firstName} ${lastName} ${t("General:label_143")}`} />

            <div className="flex flex-jc-a mt-12">
                <div className="flex flex-ai-center">
                    <img src={imgUrl} className="edit-role-user-img" />
                </div>

                <div className="flex flex-d-column">
                    <div className="flex">

                        <div className="flex flex-d-column">
                            <p className="fs-14 c-text fw-600">{transactionsInfo.numberJobs}</p>
                            <p className="fs-14 c-text mt-8">{t("General:label_286")}</p>
                            <div className="flex flex-ai-center mt-12">
                                <FontAwesomeIcon icon={solid("star")} className="fs-14 color-gim mb-2 mr-6" />
                                <p className="fs-13-lh color-text fw-600 mr-4">{Number(gimScore).toFixed(1)}</p>
                                <p className="fs-13-lh color-text fw-600">{"Gim"}</p>
                            </div>
                        </div>

                        <div className="flex flex-d-column ml-20">
                            <p className="fs-14 c-text fw-600">{transactionsInfo.numberTasks}</p>
                            <p className="fs-14 c-text mt-8">{t("General:label_287")}</p>
                            <div className="flex flex-ai-center mt-12">
                                <FontAwesomeIcon icon={solid("star")} className="fs-14 color-gimmer mb-2 mr-6" />
                                <p className="fs-13-lh color-text fw-600 mr-4">{Number(gimmerScore).toFixed(1)}</p>
                                <p className="fs-13-lh color-text fw-600">{"Gimmer"}</p>
                            </div>
                        </div>

                    </div>

                    <div className="flex flex-d-column mt-10 c-text">
                        <div className="flex flex-ai-center mt-8">
                            <div className={`circle-skill ${Tax_Information ? "apple-bg" : "persian-red-bg"}`} />
                            <p className="fs-13 ml-6">{t("General:label_291")}</p>
                        </div>
                        {
                            nss_information ?
                            <div className="">
                                <div className="flex flex-ai-center mt-8">
                                    <div className={`circle-skill apple-bg`} />
                                    <p className="fs-13 ml-6">{`${t("General:label_294")}: `} <span className="ml-4">{nss_information.nombre}</span></p>
                                </div>
                                <div className="flex flex-ai-center mt-8">
                                    <div className={`circle-skill apple-bg`} />
                                    <p className="fs-13 ml-6">{`${"CURP"}: `} <span className="ml-4">{nss_information.curp}</span></p>
                                </div>
                                <div className="flex flex-ai-center mt-8">
                                    <div className={`circle-skill apple-bg`} />
                                    <p className="fs-13 ml-6">{`${"NSS"}: `} <span className="ml-4">{nss_information.nss}</span></p>
                                </div>
                            </div>
                            :
                            <div className="flex flex-ai-center mt-8">
                                <div className={`circle-skill persian-red-bg`} />
                                <p className="fs-13 ml-6">{t("General:label_292")}</p>
                            </div>
                        }
                        
                    </div>

                </div>

            </div>

            <div className="center">
                <div className="flex flex-d-column">
                    <div className="flex flex-ai-center mt-18">
                        <p className="fs-13 ml-6 color-gim">{`${t("Home:manageUsers:label_01")}: `} <span className="ml-4 fw-700">{GimTransactionsTotal}</span></p>
                    </div>
                    <div className="flex flex-ai-center mt-8">
                        <p className="fs-13 ml-6 color-gim">{`${t("Home:manageUsers:label_02")}: `} <span className="ml-4 fw-700 color-green-pass">{GimTransactionsFinished}</span></p>
                    </div>
                    <div className="flex flex-ai-center mt-8">
                        <p className="fs-13 ml-6 color-gim">{`${t("Home:manageUsers:label_03")}: `} <span className="ml-4 fw-700 color-alert">{GimTransactionsCancelled}</span></p>
                    </div>

                    <div className="flex flex-ai-center mt-10">
                        <p className="fs-13 ml-6 color-gimmer">{`${t("Home:manageUsers:label_04")}: `} <span className="ml-4 fw-700">{GimmerTransactionsTotal}</span></p>
                    </div>
                    <div className="flex flex-ai-center mt-8">
                        <p className="fs-13 ml-6 color-gimmer">{`${t("Home:manageUsers:label_05")}: `} <span className="ml-4 fw-700 color-green-pass">{GimmerTransactionsFinished}</span></p>
                    </div>
                    <div className="flex flex-ai-center mt-8">
                        <p className="fs-13 ml-6 color-gimmer">{`${t("Home:manageUsers:label_06")}: `} <span className="ml-4 fw-700 color-alert">{GimmerTransactionsCancelled}</span></p>
                    </div>
                </div>
            </div>

            <div className="gray-h-line mt-10 mb-10" />

            <label className="fs-14 black fw-600 mb-6" htmlFor="role">{t("General:label_138")} </label>
            {
                isSuperAdmin
                ? <div className=""> <p className="fs-14">{"Super_Admin"}</p> </div>
                :
                <InputList text={roleValue?.name || ""} width={"100%"} height="3.6rem" heightList="18rem" error={error} >
                    {
                        roles.map((r: Role, index: number) => {
                            return(
                                <div key={r.id} className="input-list-item" onClick={() => selectRole(r)}>
                                    <p className="fs-14">
                                        { r.name }
                                    </p>
                                </div>
                            )
                        })
                    }
                </InputList>
            }
            
            {
                jobs.length > 0
                ?
                <div className="flex-1">
                    <div className="gray-h-line mt-10 mb-10" />

                    <div className="center">
                        <div className="center flex-d-column info-best-skill-card">
                            <p className="fs-14 fw-600">{t("General:label_288")}</p>
                            <p className="fs-14 mt-8">{jobNames[jobs[0]]}</p>
                        </div>
                        <div className="flex flex-d-column ml-40">
                            <p className="fs-13 fw-600">{t("General:label_289")}</p>
                            {
                                jobs.map((job) => {
                                    return (
                                        <div key={job} className="flex flex-ai-center mt-8">
                                            <div className="circle-skill gim-bg" />
                                            <p className="fs-12 ml-6">{jobNames[job]}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                : 
                <div className="center flex-1">
                    <p className="fs-14 fw-600">{t("General:label_293")}</p>
                </div>
            }

            <ConfirmButton disabled={isSuperAdmin} text={t("General:label_016")} width="100%" />

            { loading && <LoadingSpinner fullPage={true} /> }
        </form>
    )
}

export default EditUserRoleModal